import React, { useContext, useEffect, useRef, useState } from "react";
import styles from "./Functions.module.scss";
import { Button, makeStyles } from "@material-ui/core";
import { ArrowDropDownOutlined, ArrowDropUpOutlined } from "@material-ui/icons";
import axios from "axios";
import UrlLinks from "../../../UrlLinks";
import ResponseModal from "../../../Utils/dialogs/ResponseModal";
import { useSelector } from "react-redux";
import FollowUp from "../components/FollowUp";
import { AuthContext } from "../../../services/AuthProvider";
import { createPortal } from "react-dom";

const useStyles = makeStyles((theme) => ({
  statusDropdownDiv: {
    "& .MuiButton-root": {
      border: "1px solid #1c4980",
      color: "#1c4980",
      textTransform: "inherit",
      padding: "5px 9px",
      fontSize: "inherit",
      fontWeight: "normal",
      height: "38px",
    },
    "& .MuiButton-root.Mui-disabled": {
      border: "1px solid #cccccc",
      color: "rgba(0, 0, 0, 0.26)",
    },
  },
  statusDropdownDiv2: {
    "& .MuiButton-root": {
      textTransform: "inherit",
      fontSize: "inherit",
      fontWeight: "normal",
      width: "100%",
    },
    "& .MuiButton-root.Mui-disabled": {
      color: "rgba(0, 0, 0, 0.26)",
    },
  },
  appDbStatusButton: {
    padding: "0",
    "&:hover": {
      backgroundColor: "transparent",
    },
  },
}));

const CustomStatusDropdown = (props) => {
  const {
    disabled = false,
    searchList = [],
    assignIds = [],
    selectedSubStatus = null,
    dropdownName,
    buttonName = "",
    toggleStatusUpdated = false,
    setToggleStatusUpdated,
    uniqueKey = "",
    updateMyData,
    fileName = "",
    handleActions,
  } = props;
  const { applicationDb } = useSelector((state) => state);
  const { tabValue } = applicationDb;

  const classes = useStyles();
  const dropdownRef = useRef(null);
  const { showToast } = useContext(AuthContext);

  const [statusDropdownOpen, setStatusDropdownOpen] = useState(false);
  const [searchActions, setSearchActions] = useState("");
  const [invalidData, setInvalidData] = useState();
  const [responseData, setResponseData] = useState();
  const [openResponseModal, setOpenResponseModal] = useState(false);
  const [statusList, setStatusList] = useState(searchList);
  const [openFollowUpModal, setOpenFollowUpModal] = useState(false);
  const [nestedDropdownStyle, setNestedDropdownStyle] = useState({});

  const handleStatusDropdown = (event) => {
    if (dropdownRef.current && uniqueKey === "updateDataAppDb") {
      const rect = dropdownRef.current.getBoundingClientRect();
      setNestedDropdownStyle({
        position: "absolute",
        top: `${rect.top + window.scrollY}px`,
        left: `${rect.left - 128}px`,
        zIndex: 1300,
        backgroundColor: "#fff",
        padding: "10px 0",
      });
    }
    setStatusDropdownOpen((prev) => !prev);
  };

  const handleSearchAction = (event, itemList) => {
    setSearchActions(itemList.typeKey);
    if (itemList.typeKey === 18 || itemList.typeKey === 19) {
      setOpenFollowUpModal(true);
    }
  };

  //  function to create an invalid excel sheet
  const createInvalidData = (records) => {
    let totalUploaded = 0;
    if (records.length > 0) {
      let list = [];
      records.map((record) => {
        if (
          record.assignStatus === "Application status changed successfully "
        ) {
          totalUploaded++;
        } else {
          list.push({
            assignId: record.assignId || "",
            assignStatus: record.assignStatus || "Worker not assigned",
            responseId: record.responseId || "",
          });
        }
        return true;
      });
      const summary = {
        totalAttempted: records.length,
        totalUploaded: totalUploaded,
      };
      setResponseData(summary);
      return list.length > 0 ? list : null;
    }
  };

  const handleStatusUpdate = () => {
    let data = {
      assignIds: assignIds,
      statusId: searchActions,
      userId: localStorage.getItem("userID"),
    };
    axios
      .post(
        `${UrlLinks.baseUrl}${UrlLinks.leadData.setLeadApplicationStatusInBulk}?assignIds=${data.assignIds}&statusId=${data.statusId}&userId=${data.userId}`
      )
      .then((response) => {
        if (searchActions == 9 || searchActions == 10) {
          if (response.data.response) {
            setInvalidData(createInvalidData(response.data.response));
          } else {
            setResponseData([]);
          }
        } else {
          showToast("success", "Success", "Remark updated successfully.");
        }
      })
      .catch((err) => {
        console.log("err", err);
        showToast("error", "Something went wrong, please try after sometime.");
      });
    setToggleStatusUpdated(!toggleStatusUpdated);
    setStatusDropdownOpen(false);
    updateMyData();
  };

  useEffect(() => {
    if (responseData) {
      setOpenResponseModal(true);
    }
  }, [responseData]);

  useEffect(() => {
    function handleClickOutside(event) {
      const dropdown = dropdownRef.current;
      const portalDropdown = document.querySelector(".portal-dropdown");

      if (
        dropdown &&
        !dropdown.contains(event.target) &&
        (!portalDropdown || !portalDropdown.contains(event.target))
      ) {
        setStatusDropdownOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [dropdownRef]);

  useEffect(() => {
    if (uniqueKey === "statusUpdate") {
      let list = [];
      searchList.map((item) => {
        if (tabValue === "FreshLeads") {
          if (
            selectedSubStatus?.id === 17 &&
            (item.typeKey === 4 ||
              item.typeKey === 16 ||
              item.typeKey === 18 ||
              item.typeKey === 19)
          ) {
            list.push({
              typeKey: item.typeKey,
              typeValue: item.typeValue,
            });
          } else if (
            selectedSubStatus?.id === 18 &&
            (item.typeKey === 4 || item.typeKey === 16 || item.typeKey === 19)
          ) {
            list.push({
              typeKey: item.typeKey,
              typeValue: item.typeValue,
            });
          } else if (
            selectedSubStatus?.id === 19 &&
            (item.typeKey === 4 || item.typeKey === 16)
          ) {
            list.push({
              typeKey: item.typeKey,
              typeValue: item.typeValue,
            });
          } else if (
            selectedSubStatus?.id === 4 &&
            (item.typeKey === 18 || item.typeKey === 19)
          ) {
            list.push({
              typeKey: item.typeKey,
              typeValue: item.typeValue,
            });
          }
        } else if (tabValue === "Applied") {
          if (selectedSubStatus?.id === 21 && item.typeKey === 8) {
            list.push({
              typeKey: item.typeKey,
              typeValue: item.typeValue,
            });
          }
        } else if (tabValue === "Training") {
          if (selectedSubStatus?.id === 8 && item.typeKey === 7) {
            list.push({
              typeKey: item.typeKey,
              typeValue: item.typeValue,
            });
          }
        } else if (tabValue === "Work") {
          if (selectedSubStatus?.id === 9 && item.typeKey === 11) {
            list.push({
              typeKey: item.typeKey,
              typeValue: item.typeValue,
            });
          }
        }
        return true;
      });

      let sortedList = list.sort((a, b) =>
        a.typeValue.localeCompare(b.typeValue)
      );
      setStatusList(sortedList);
    } else if (uniqueKey === "updateDataAppDb") {
      setStatusList(searchList);
    }
  }, [searchList, selectedSubStatus]);

  const dropdownContent = () => {
    return (
      <div
        className={`${styles.statusDropdownList} portal-dropdown`}
        style={nestedDropdownStyle}
      >
        {statusList?.map((itemList, index) =>
          itemList.value ? (
            <div
              key={index}
              onClick={(e) => {
                e.preventDefault();
                handleActions(e, "updateDataAppDb", itemList);
                setStatusDropdownOpen(false);
              }}
              className={styles.itemList}
            >
              {itemList.label}
            </div>
          ) : null
        )}
      </div>
    );
  };

  const dropdownContentRadio = () => {
    return (
      <div className={styles.statusDropdownList}>
        {statusList?.map((itemList, index) => (
          <div className={styles.itemListRadio} key={index}>
            <input
              type="radio"
              name="statusOption"
              onChange={(e) => handleSearchAction(e, itemList)}
            />
            {itemList.typeValue}
          </div>
        ))}
        <Button
          onClick={(e) => handleStatusUpdate(e, searchActions)}
          variant="contained"
          className="dataButton"
          disabled={searchActions === "" ? true : false}
        >
          {buttonName}
        </Button>
      </div>
    );
  };

  return (
    <div
      ref={dropdownRef}
      className={
        uniqueKey === "updateDataAppDb"
          ? classes.statusDropdownDiv2
          : classes.statusDropdownDiv
      }
    >
      <Button
        onClick={(e) => handleStatusDropdown(e)}
        disabled={disabled}
        className={
          uniqueKey === "updateDataAppDb" ? classes.appDbStatusButton : ""
        }
        style={{
          padding: uniqueKey === "updateDataAppDb" ? "6px 16px" : "",
          justifyContent: "normal",
        }}
      >
        {dropdownName}
        {statusDropdownOpen ? (
          <ArrowDropUpOutlined />
        ) : (
          <ArrowDropDownOutlined />
        )}
      </Button>
      {statusDropdownOpen
        ? uniqueKey === "updateDataAppDb"
          ? createPortal(dropdownContent(), document.body)
          : uniqueKey === "statusUpdate"
          ? dropdownContentRadio()
          : null
        : null}
      {openResponseModal && (
        <ResponseModal
          openResponseModal={openResponseModal}
          setOpenResponseModal={setOpenResponseModal}
          setOpenOnboardingModal={false}
          responseData={responseData}
          invalidData={invalidData}
          uniqueKey={uniqueKey}
          fileName={fileName}
        />
      )}
      {openFollowUpModal && (
        <FollowUp
          openOnboardingModal={openFollowUpModal}
          setOpenOnboardingModal={setOpenFollowUpModal}
          showToast={showToast}
          updateMyData={updateMyData}
          title={searchActions === 18 ? "Follow Up 1" : "Follow Up 2"}
          uniqueKey="followUp"
          assignIds={assignIds}
          searchActions={searchActions}
        />
      )}
    </div>
  );
};

export default CustomStatusDropdown;
